const styles = {
  submitButton: {
    backgroundColor: "#043D90",
    width: "100%",
    height: "40px",
  },
};

export default styles;
